"use client";

import { Button } from "@/components/ui/button";
import { BellIcon } from "@/components/ui/bell";
import { XIcon } from "@/components/ui/x";

/**
 * Inline "turn on response notifications" card — rendered above the
 * composer in ConversationInput, in the same spot as the tool-write Notice,
 * rather than as a toast. Clicking "Turn on" arms an in-app toast for this
 * one turn if the user navigates elsewhere before it finishes — see
 * src/lib/notify-on-finish.ts and use-global-response-notifications.ts.
 */
export const ResponseNotificationPrompt = ({
  onTurnOn,
  onDismiss,
}: {
  onTurnOn: () => void;
  onDismiss: () => void;
}) => (
  <div className="relative mb-2 rounded-2xl border border-border bg-card p-4 shadow-lg">
    <button
      aria-label="Dismiss"
      className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
      onClick={onDismiss}
      type="button"
    >
      <XIcon size={14} />
    </button>
    <div className="flex items-center gap-4 pr-6">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <BellIcon size={18} className="shrink-0" />
          <p className="text-sm font-semibold text-foreground">Turn on response notifications</p>
        </div>
        <p className="mt-1 text-sm text-muted-foreground">
          Feel free to step away — we&apos;ll notify you as soon as the response is ready.
        </p>
      </div>
      <Button className="shrink-0 rounded-full" onClick={onTurnOn} size="sm" type="button">
        Turn on
      </Button>
    </div>
  </div>
);
